import { capitalizeName } from 'features/command-center/utils';
import startCase from 'lodash/startCase';
import moment from 'moment';
import { DateFormats } from 'UI/constants/defaults';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { convertMinutesToSeconds, roundDecimals } from 'UI/utils';

import {
  ACTIVE_METRICS,
  EMPLOYEE_STATUS_METRICS,
  FEEDBACK_ACTIVITIES_METRICS,
  GOAL_METRICS,
  METRICS,
  TENURE_RANGES
} from './OverallPerformance.constants';

export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    recruiterName: {
      empNo: item.empNo,
      name: capitalizeName(item?.name)
    },
    team: {
      managerEmpNo: item.managerEmpNo,
      team: capitalizeName(item?.team)
    },
    inMails: {
      inMails: item.inMails,
      inMailsGoals: item.inMailsGoals
    },
    avgInMails: {
      avgInMails: item.avgInMails,
      avgInMailsGoals: item.avgInMailsGoals
    },
    bulks: {
      bulks: item.bulks,
      bulksGoal: item.bulksGoal
    },
    callsTime: {
      callsTime: item?.callsTime ? convertMinutesToSeconds(item?.callsTime) : 0,
      callsTimeGoal: item?.callsTimeGoal ? convertMinutesToSeconds(item.callsTimeGoal) : 0
    },
    calls: {
      calls: item.calls,
      callsGoal: item.callsGoal
    },
    peopleReached: {
      peopleReached: item.peopleReached,
      peopleReachedGoal: item.peopleReachedGoal
    },
    posts: {
      todayLivePosts: item.todayLivePosts,
      livePostingsDailyGoal: item.livePostingsDailyGoal
    },
    sendouts: {
      sendouts: item.sendouts,
      sendoutsGoal: item.sendoutsGoal
    },
    productionYTD: item.productionYtd,
    cashInYTD: item.cashInYtd,
    outStandingBillings: item.outstandingBillings,
    hireDate: item?.hireDate && moment.parseZone(item?.hireDate).format(DateFormats.SimpleDate),
    termDate: item?.termDate && moment.parseZone(item?.termDate).format(DateFormats.SimpleDate),
    tenure: item?.tenure ? TENURE_RANGES[item.tenure] : null,
    lastFeedbackActivityType:
      item?.lastFeedbackActivityType && startCase(item?.lastFeedbackActivityType),
    avgFeePercentage: item?.avgFeePercentage && roundDecimals(item?.avgFeePercentage, 2)
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};

export const getFinalMetrics = checkIfFeatureFlagEnabled => {
  const conditionalMetrics = [
    {
      flag: FeatureFlags.OverallPerformanceFeedbackActivityColumns,
      metrics: FEEDBACK_ACTIVITIES_METRICS
    },
    {
      flag: FeatureFlags.OverallPerformanceSecondVersion,
      metrics: EMPLOYEE_STATUS_METRICS
    },
    {
      flag: FeatureFlags.OverallPerformanceMetricsFilters,
      metrics: ACTIVE_METRICS
    }
  ];

  const enabledMetrics = conditionalMetrics
    .filter(({ flag }) => checkIfFeatureFlagEnabled(flag))
    .map(({ metrics }) => metrics);

  return [METRICS, GOAL_METRICS, ...enabledMetrics].join(',');
};
